import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as UAParser from 'ua-parser-js';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'android-app-banner',
  templateUrl: './android-app-banner.html',
  styleUrls: ['./android-app-banner.scss']
})

export class AndroidAppBanner implements OnInit{
  bannerClosed = false;
  bannerVisible = false;
  parser = new UAParser();
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser && sessionStorage.getItem('bannerClosed')) {
      this.bannerClosed = true;
    }
    const oSCheck = this.parser.getOS();

    if (oSCheck.name === "iOS") {
      this.bannerVisible = true
    }
  }

  closeBanner() {
    this.bannerClosed = true;
    if (this.isBrowser) {
      sessionStorage.setItem('bannerClosed', 'true');
    }
  }

  openMobileApp() {
    if (!this.isBrowser) return;
    window.location.href = `${environment.apiUrl}/mobile`;
  }

}
